<template>
  <div class="margin-b-standard" data-testing="qti-card">
    <RightSidebarTitle :title="'QTI Question Bank'" />
    <p class="qti-unsupported-message">This tool is no longer supported.</p>
  </div>
</template>
<script lang="ts" setup>
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
</script>
<style lang="scss" scoped>
.qti-unsupported-message {
  font-size: 0.875rem;
  color: $grey60;
  padding: 0.5rem 0;
}
</style>
